import React from "react";
import styled from "styled-components";
import { FontWeight, Radius, background, border, content } from "@glossy";
import Icon, { Glyph } from "@ui-kit/icon";

interface IProps {
  glyph: Glyph;
  label?: string;
  shape?: "square" | "disc";
  iconSize?: number;
  transparent?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

const Root = styled.div<Partial<IProps>>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 36px;
  width: ${(props) => !props.label && "36px"};
  gap: 10px;
  padding: 0 10px;
  border-radius: ${({ shape }) =>
    shape === "square" ? Radius.ExtraSmall : "50%"};
  cursor: pointer;
  color: ${(props) =>
    content(props, props.transparent ? "tertiary" : "primary")};
  border: 1px solid ${border};
  background-color: ${(props) => !props.transparent && background(props)};
  font-weight: ${FontWeight.Medium};

  &:hover {
    color: ${(props) => content(props, "secondary")};
    background-color: ${background};
  }

  * {
    flex-shrink: 0;
  }
`;

const KomonNavigationNavbarButton = ({
  glyph,
  label,
  shape = "square",
  iconSize = 15,
  transparent = false,
  onClick,
  className,
}: IProps) => (
  <Root
    shape={shape}
    label={label}
    transparent={transparent}
    onClick={onClick}
    className={className}
  >
    <Icon glyph={glyph} size={iconSize} />
    {label}
  </Root>
);

export default KomonNavigationNavbarButton;
